import { RightPanel } from "../models/right-panel-models";
import * as RightPanelActions from "../actions/right-panel-actions";

export const initialState: RightPanel = {
  display: true,
  isCollapsed: true,
  panels: {
    inferredData: {
      clearDimension: false,
      default: "default",
      selected: "implied",
      // values: []
    },
    analyticsData: {
      values: [],
      clearDimension: false,
      trendYear: "",
    },
    historicalEstimates: {
      clearDimension: false,
      revisionDateList: [null],
      changedDate: "",
      default: "Current",
      effectiveStart: "",
      type: "off",
      values: [null],
    },
    periods: {
      clearDimension: false,
      firstEstimatedYear: null,
      multiPeriod: true,
      from: null,
      to: null,
      selectedFrom: null,
      selectedTo: null,
      interimType: "All",
      periodType: "AI",
    },
    visualizations: {
      clearDimension: false,
      values: [
        { name: "Show Variation", slider: -9, selected: "" },
        { name: "Revisions", slider: -9, selected: "", value: "-6Month" },
        {
          name: "High / Low",
          selected: false,
          high_low_src: "all",
          values: [
            { name: "High", selected: false },
            { name: "Low", selected: false },
          ],
        },
        { name: "Surprise", slider: 1, selected: "" },
      ],
    },
  },
  accountingBasis: {
    selected: undefined,
    clearDimension: false,
  },
  activeCut: {
    cut: undefined,
  },
  sourceMeta: {
    ticker: undefined,
    isClear: false,
    selectedSources: [],
    loaded: false,
    appliedGridFilters: false,
  },
};

export function rightPanelReducer(
  state: RightPanel = initialState,
  action: RightPanelActions.Actions,
) {
  switch (action.type) {
    case RightPanelActions.SET_SOURCE_META_LOADING:
      return {
        ...state,
        sourceMeta: {
          ...state.sourceMeta,
          loaded: false,
        },
      };

    case RightPanelActions.SET_DISPLAY:
      return {
        ...state,
        display: action.payload,
      };

    case RightPanelActions.SET_RIGHT_PANEL_COLLAPSED:
      return {
        ...state,
        isCollapsed: action.payload,
      };

    case RightPanelActions.GET_SOURCE_META:
      return {
        ...state,
        sourceMeta: action.payload,
      };

    case RightPanelActions.SET_SOURCE_META_GRID_FILTERS:
      return {
        ...state,
        sourceMeta: {
          ...state.sourceMeta,
          appliedGridFilters: action.payload,
        },
      };

    case RightPanelActions.SET_INFERRED_SELECTED:
      return {
        ...state,
        panels: {
          ...state.panels,
          inferredData: { ...action.payload },
        },
      };

    case RightPanelActions.GET_ACCOUNTING_BASIS_PREFS:
      return {
        ...state,
        accountingBasis: { ...initialState.accountingBasis },
      };

    case RightPanelActions.SET_ACCOUNTING_BASIS_PREFS:
      return {
        ...state,
        accountingBasis: { ...action.payload },
      };

    case RightPanelActions.GET_ACTIVE_CUT:
      return {
        ...state,
        activeCut: { ...initialState.activeCut },
      };

    case RightPanelActions.SET_ACTIVE_CUT:
      return {
        ...state,
        activeCut: { ...action.payload },
      };

    case RightPanelActions.RESET_INFERRED_SELECTED:
      return {
        ...state,
        panels: {
          ...state.panels,
          inferredData: { ...initialState.panels.inferredData },
        },
      };

    case RightPanelActions.SET_ANALYTICS_DATA:
      return {
        ...state,
        analyticsData: { ...action.payload },
      };

    case RightPanelActions.SET_HISTORICAL_ESTIMATES:
      return {
        ...state,
        panels: {
          ...state.panels,
          historicalEstimates: { ...action.payload },
        },
      };

    case RightPanelActions.RESET_HISTORICAL_ESTIMATES:
      return {
        ...state,
        panels: {
          ...state.panels,
          historicalEstimates: { ...initialState.panels.historicalEstimates },
        },
      };

    default:
      return state;

    case RightPanelActions.SET_PERIODS:
      return {
        ...state,
        panels: {
          ...state.panels,
          periods: { ...action.payload },
        },
      };

    case RightPanelActions.RESET_PERIODS:
      return {
        ...state,
        panels: {
          ...state.panels,
          periods: { ...initialState.panels.periods },
        },
      };

    case RightPanelActions.SET_VISUALIZATIONS:
      return {
        ...state,
        panels: {
          ...state.panels,
          visualizations: { ...action.payload },
        },
      };

    case RightPanelActions.RESET_VISUALIZATIONS:
      return {
        ...state,
        panels: {
          ...state.panels,
          visualizations: { ...initialState.panels.visualizations },
        },
      };

    case RightPanelActions.RESET_RIGHTPANEL_SETTIINGS:
      return {
        ...state,
        panels: { ...initialState.panels },
      };
  }
}
